import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plane",
  "use": "plane-usage",
  "viewBox": "0 0 500 500",
  "content": "<symbol viewBox=\"0 0 500 500\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"plane\">\n<path d=\"M460.504 39.5161L195.112 304.909\" stroke=\"currentColor\" stroke-width=\"14.5161\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M277.454 460.484L195.091 304.909L39.5161 222.546L460.484 39.5161L277.454 460.484Z\" stroke=\"currentColor\" stroke-width=\"14.5161\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol